import React from 'react';
import ProtocolForm from './ProtocolForm.js';

export const EditProtocol = ({ protocol, onSuccess, onCancel }) => {
  return (
    <div className="AddProtocol">
      <ProtocolForm
        initialData={protocol}
        mode="edit"
        onSuccess={onSuccess}
        onCancel={onCancel}
      />
    </div>
  );
}

export default EditProtocol;
